import { authenticatedUser } from 'header-scripts';
import placesListModule from '../placesListModule';

function layout(languageResource, urlService, $filter, thumbnailConstants) {
  'ngInject';

  const lang = languageResource;
  const gameDetailsUrl = '/games/{placeId}/gamename';
  const profileUrl = `/users/${authenticatedUser?.id}/profile`;
  const myFavoritePlaceUrl = `/users/${authenticatedUser?.id}/favorites#!/places`;
  const createLinkHtml = "<a class='text-link' href='{creatorUrl}' >{creatorName}</a>";

  return {
    seeAllBtnText: lang.get('Action.SeeAll'), // "See All",
    gamesListDisplayName: lang.get('Label.PlacesListName'), // "Games"lang.get("Label.PlacesListName"),
    playerInteractionTitle: lang.get('Label.ContextMenuTitle'),
    maxNumberOfGamesInList: 6,
    maxNumberOfDisplayAvatars: 3,
    maxNumberOfDisplayAvatarsInLargeGameTile: 5,
    numberOfGamesFetchInList: 12,
    isRealTimePlacesListLoaded: false,

    gamesListSeeAllLinks: {
      MyRecent: urlService.getAbsoluteUrl('games?SortFilter=6'),
      FriendActivity: urlService.getAbsoluteUrl('games?SortFilter=17'),
      TopRetaining: urlService.getAbsoluteUrl('games?SortFilter=16'),
      MyFavorite: urlService.getAbsoluteUrl(myFavoritePlaceUrl),
      Popular: urlService.getAbsoluteUrl('games?SortFilter=1'),
      PersonalRecommendation: urlService.getAbsoluteUrl('games?SortFilter=24'),
      MyLibrary: urlService.getAbsoluteUrl('games?SortFilter=25'),
    },

    getGameDetailsPageUrl(placeId) {
      const placeUrl = $filter('formatString')(gameDetailsUrl, { placeId });
      return urlService.getAbsoluteUrl(placeUrl);
    },

    getProfilePageUrl(userId) {
      const profilePageUrl = $filter('formatString')(profileUrl, { userId });
      return urlService.getAbsoluteUrl(profilePageUrl);
    },

    getPlayerCountLabel(playerCount) {
      return lang.get('Label.PlayingPhrase', { playerCount }); // {playerCount} Playing
    },

    getCreatorBy(creatorUrl, creatorName) {
      const creatorLink = $filter('formatString')(createLinkHtml, {
        creatorUrl,
        creatorName
      }); // By {creatorLink}
      return lang.get('Label.CreatorBy', { creatorLink });
    },

    interactionLabels: {
      viewDetails: lang.get('Action.ViewDetails'),
      joinGame: lang.get('Action.JoinGame')
    },
    scrollDirection: {
      prev: 'prev',
      next: 'next'
    },
    scrollingParams: {
      curIndex: 0,
      leftOffset: 480,
      padding: 6,
      leftStyle: {
        left: 0
      },
      isLeftScrollerDisabled: false,
      isRightScrollerDisabled: false,
      currentGameTileWidth: 0
    },

    thumbnailTypes: thumbnailConstants.thumbnailTypes,
    avatarHeadshotSizes: thumbnailConstants.avatarHeadshotSize
  };
}

placesListModule.factory('layout', layout);

export default layout;
